import { useState } from 'react';

import { ActionIcon, Modal, Tooltip } from '@mantine/core';
import { IconCoffee } from '@tabler/icons-react';

import { useIsMobile } from '@/hooks/useIsMobile';

interface KofiButtonProps {
  username: string;
}

export function KofiButton({ username }: KofiButtonProps) {
  const [opened, setOpened] = useState(false);
  const isMobile = useIsMobile();

  return (
    <>
      <div
        style={{
          position: 'fixed',
          bottom: 'max(16px, env(safe-area-inset-bottom, 16px))',
          left: 'max(16px, env(safe-area-inset-left, 16px))',
          zIndex: 1000,
        }}
      >
        <Tooltip label="Support on Ko-fi" position="right" withArrow>
          <ActionIcon
            onClick={() => setOpened(true)}
            size={isMobile ? 'lg' : 'xl'}
            radius="md"
            variant="gradient"
            gradient={{ from: 'cyan', to: 'blue', deg: 135 }}
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
            }}
            aria-label="Support on Ko-fi"
          >
            <IconCoffee size={isMobile ? 20 : 24} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </div>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Support on Ko-fi"
        size="lg"
        centered
        styles={{
          content: {
            backgroundColor: 'var(--mantine-color-dark-7)',
          },
          header: {
            backgroundColor: 'var(--mantine-color-dark-7)',
            borderBottom: '1px solid var(--mantine-color-dark-5)',
          },
          title: {
            color: 'var(--mantine-color-gray-0)',
            fontWeight: 600,
          },
          body: {
            padding: 0,
          },
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 16,
            borderRadius: '0 0 8px 8px',
          }}
        >
          <iframe
            src={`https://ko-fi.com/${username}/?hidefeed=true&widget=true&embed=true`}
            style={{
              width: '100%',
              height: '600px',
              border: 'none',
              display: 'block',
            }}
            title="Ko-fi donation widget"
            sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-forms"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </Modal>
    </>
  );
}
